/**
 * Call einstein to enable or disable tracking. Based on onetrust sdk
 */

export default function einsteinCookies() {
    window.addEventListener(
        'onetrustloaded',
        () => {
            const originUrl = window.location.origin;
            const relativeEinsteinUrl = $(
                'meta[name=einsteinTrackingUrl]',
            ).attr('content');
            const url = new URL(relativeEinsteinUrl, originUrl);
            if (window.OneTrust) {
                let isCustomCall = false;
                $(document).on('click', '#close-pc-btn-handler', () => {
                    isCustomCall = true;
                    window.OneTrust.RejectAll();
                });
                $('.einstein-slot').toggleClass(
                    'd-none',
                    window.OnetrustActiveGroups.indexOf('C0003') === -1,
                );
                $('.einstein-slot-fallback').toggleClass(
                    'd-none',
                    window.OnetrustActiveGroups.indexOf('C0003') !== -1,
                );
                window.OneTrust.OnConsentChanged(() => {
                    if (window.OnetrustActiveGroups.indexOf('C0003') !== -1) {
                        url.searchParams.append('consent', true);
                        $.ajax({
                            url: url.toString(),
                            success: () => {
                                $('.einstein-slot').removeClass('d-none');
                                $('.einstein-slot-fallback').addClass('d-none');
                            },
                        });
                    } else {
                        url.searchParams.append('consent', false);
                        if (!isCustomCall) {
                            $.ajax({
                                url: url.toString(),
                                success: () => {
                                    $('.einstein-slot').addClass('d-none');
                                    $('.einstein-slot-fallback').removeClass(
                                        'd-none',
                                    );
                                },
                            });
                        }
                    }
                    isCustomCall = false;
                });
            }
        },
        { once: true },
    );
}
